/**
 * TextField — Astryx TextInput 에 네이티브 input 속성 타입을 되살린 얇은 래퍼.
 *
 * 왜 필요한가:
 *   Astryx TextInput 은 `...rest` 를 그대로 <input> 에 스프레드하므로 `autoComplete`,
 *   `maxLength` 가 **런타임에서는 정상 동작**한다. 그런데 타입 정의(`BaseProps`)가
 *   `React.InputHTMLAttributes` 가 아니라 `React.HTMLAttributes` 를 상속해서
 *   두 속성이 타입에서만 빠져 있다 → TS2322.
 *
 *   autoComplete 는 로그인/회원가입 필드에서 비밀번호 관리자와 iOS/Android 자동완성이
 *   의존하는 속성이라 포기할 수 없다. 그래서 타입만 다시 열어준다.
 *
 * Astryx 가 BaseProps 를 InputHTMLAttributes 기반으로 고치면 이 파일은 삭제하고
 * TextInput 을 직접 쓰면 된다.
 */
import { TextInput, type TextInputProps } from "@astryxdesign/core/TextInput";

export type TextFieldProps = TextInputProps & {
  /** 자동완성 힌트 (email, current-password, new-password, off …) */
  autoComplete?: string;
  /** 최대 입력 길이 */
  maxLength?: number;
  /** form 제출용 name — Astryx 의 htmlName 별칭 */
  name?: string;
  /** 모바일 키패드 힌트 (numeric, tel, email …) — 생년월일·수량처럼 숫자만 받는 칸에 필요 */
  inputMode?: React.HTMLAttributes<HTMLInputElement>["inputMode"];
};

export default function TextField(props: TextFieldProps) {
  return <TextInput {...(props as TextInputProps)} />;
}
